import React from 'react';
import ReactGA4 from 'react-ga4';
import { Button, Col, Navbar, Row, UncontrolledCollapse } from 'reactstrap';

import { logoutUser } from '../../actions/userActions';
import optionMenuIcon from '../../assets/img/brand/optionMenuIcon.svg';
import PromotionWingmanBrand from '../../assets/img/brand/pw-logo-horizontal-color-light.svg';
import { store } from '../../index';
import SwitchToPaidConfirmModal from '../SwitchToPaid/SwitchToPaidConfirmModal';
import AvatarImage from './AvatarImg';

const img = require('../../assets/img/brand/WaveTexture.svg');

export default class CommonHeaderMobile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      openSwitchToPaid: false,
    };
    this.handleOnOptionClick = this.handleOnOptionClick.bind(this);
    this.openMenu = this.openMenu.bind(this);
    this.onEntered = this.onEntered.bind(this);
    this.onExited = this.onExited.bind(this);
  }

  onEntered() {
    this.setState({ isOpen: true });
    this.props.setShowMobileMenu(true);
  }

  onExited() {
    this.setState({ isOpen: false });
    this.props.setShowMobileMenu(false);
  }

  openMenu = () => {
    this.setState({
      isOpen: true,
    });
  };

  openSwitchToPaid = () => {
    this.setState({
      openSwitchToPaid: true,
    });
  };

  closeSwitchToPaid = () => {
    this.setState({
      openSwitchToPaid: false,
    });
  };

  handleOnOptionClick(e) {
    let value = e.target.getAttribute('value');
    if (!value) {
      value = '/app/account-settings';
    }
    document.querySelector('.menu-toggler').click();

    if (value === '/app/education-center') {
      // Track how many people clicks on "Education Center" tab
      // Google Analytics 4
      ReactGA4.event({
        category: 'Select',
        action: 'Education Center Tab Click',
        label: 'Education Center Tab Click',
      });
    }

    if (value === 'logout') {
      store.dispatch(logoutUser());
      this.props.history('/login', { replace: true });
    } else {
      this.props.history(value, { replace: true });
    }
    this.props.setShowMobileMenu(false);
  }

  // Closes the menu without navigating, for links that open in a new tab (privacy and terms).
  closeMenu = () => {
    document.querySelector('.menu-toggler').click();
    this.props.setShowMobileMenu(false);
  };

  componentDidMount() {
    this.props.setShowMobileMenu(false);
  }

  componentWillUnmount() {
    this.props.setShowMobileMenu(false);
  }

  render() {
    return (
      <>
        <Navbar className=" navbar-horizontal navbar-dark navbar-color pt-sm-0 pb-sm-0 pt-md-2 pb-md-2 pr-0 pl-0 flex-row">
          <div className="d-flex flex-row m-0 justify-content-between col">
            <a href="/" className="d-flex">
              <img
                className="promotionwingman-img-login"
                src={PromotionWingmanBrand}
                alt="Promotion Wingman brand"
                height="45"
                width="157"
              />
            </a>
            <div className="d-flex">
              <button
                id="navbar-toggler"
                className="navbar-toggler menu-toggler pt-0 pb-0 border border-0"
              >
                <img
                  className="options-btn"
                  alt="..."
                  src={optionMenuIcon}
                  onClick={this.openMenu}
                  height="36"
                  width="36"
                />
              </button>
            </div>
            <UncontrolledCollapse
              navbar
              toggler=".menu-toggler"
              style={{ height: '100vh' }}
              onExited={this.onExited}
              onEntered={this.onEntered}
            >
              <div className="text-right">
                <Button color="link" className="close-menu menu-toggler">
                  <i className="icon-close" />
                </Button>
              </div>
              <div className="body-style">
                <div className="gradient-divider d-lg-none d-sm-block" />

                <Row className="login-row-style ml-0 mr-0">
                  <span
                    value="/app/account-settings"
                    className="avatar-image d-flex"
                    onClick={this.handleOnOptionClick}
                  >
                    <AvatarImage src={this.props.user.imgUrl} value="hello" />
                  </span>
                  <Col xs={12} className="login-item-text">
                    {' '}
                    {this.props.userName}
                  </Col>
                </Row>

                <Row className="middle-row-style ml-0 mr-0">
                  <Col xs={12} className="middle-menu-item">
                    <span
                      onClick={this.handleOnOptionClick}
                      value="/app/dashboard"
                    >
                      Dashboard
                    </span>
                  </Col>
                  <Col xs={12} className="middle-menu-item container">
                    <span onClick={this.handleOnOptionClick} value="/app/study">
                      Study
                    </span>
                  </Col>
                  <Col xs={12} className="middle-menu-item">
                    <span
                      onClick={this.handleOnOptionClick}
                      value="/app/account-settings"
                    >
                      Account
                    </span>
                  </Col>
                  <Col xs={12} className="middle-menu-item">
                    <span
                      onClick={this.handleOnOptionClick}
                      value="/app/notifications"
                    >
                      Flight Log
                    </span>
                  </Col>
                  <Col xs={12} className="middle-menu-item">
                    <span
                      onClick={this.handleOnOptionClick}
                      value="/app/refer-a-friend"
                    >
                      Refer a Friend
                    </span>
                  </Col>
                  <Col xs={12} className="middle-menu-item">
                    <span onClick={this.handleOnOptionClick} value="logout">
                      Logout
                    </span>
                  </Col>
                </Row>

                <Row
                  className="last-row-style ml-0 mr-0"
                  style={{ backgroundImage: `url(${img})` }}
                >
                  <Row className="last-row-style-textContainer ml-0 mr-0 my-auto mt-2">
                    <Col xs={12} className="bottom-menu-item mb-2">
                      <span
                        onClick={this.handleOnOptionClick}
                        value="/app/resources"
                      >
                        Resources
                      </span>
                    </Col>
                    <Col xs={12} className="bottom-menu-item mb-2">
                      <span
                        onClick={this.handleOnOptionClick}
                        value="/app/education-center"
                      >
                        Education Center
                      </span>
                    </Col>
                    <Col xs={12} className="bottom-menu-item mb-2">
                      <a
                        href="https://kaplan.com/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={this.closeMenu}
                      >
                        Privacy Policy
                      </a>
                    </Col>
                    <Col xs={12} className="bottom-menu-item mb-2">
                      <a
                        href="https://promotionwingman.com/terms-of-service/"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={this.closeMenu}
                      >
                        Terms of Service
                      </a>
                    </Col>
                  </Row>
                </Row>
              </div>
            </UncontrolledCollapse>
          </div>
        </Navbar>
        {this.props.userSubscription &&
          this.props.userSubscription.status === 'trialing' && (
            <>
              <div
                className="become-paid-mobile"
                onClick={this.openSwitchToPaid}
              >
                <div>Activate Subscription</div>
                <i className="icon-chevron_right" />
              </div>
              <SwitchToPaidConfirmModal
                userSubscription={this.props.userSubscription}
                user={this.props.user}
                isOpen={this.state.openSwitchToPaid}
                onClose={this.closeSwitchToPaid}
                activateSubscription={this.props.activateSubscription}
                subscriptionActivationSucces={
                  this.props.subscriptionActivationSucces
                }
                subscriptionActivationWaiting={
                  this.props.subscriptionActivationWaiting
                }
                subscriptionActivationMessage={
                  this.props.subscriptionActivationMessage
                }
              />
            </>
          )}
      </>
    );
  }
}
